import railsPerModuleTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/railsPerModuleTooltip';
export const apiField = 'rails_per_module'
export const railsPerModule = {
  type: 'Select',
  apiField: apiField,
  label: 'rails_per_module',
  tooltip: railsPerModuleTooltip,
  data: [2,3].map(load => ({ name: String(load), value: Number(load) })),
};
